import {ClsLicenciasPU} from '../cls-cambio-de-propietario';
import {ClsErrores} from '../cls-errores';
import {ClsPeticionPresupuestos} from './cls-pr-generico';

export class ClsPeticionListaLicenciasVigentes extends ClsPeticionPresupuestos {
  IdEmpresa: bigint;
  ValidaAdmin: boolean;
}
export class ClsRespuestaListaLicenciasVigentes {
  licenciasPU: ClsLicenciasPU[];
  errores: ClsErrores;
}
export class ClsCambiaPropietarioPresupuesto extends ClsPeticionPresupuestos {
  EmailNuevo: string;
}
